import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Accordion, Card, Button } from 'react-bootstrap';

import cartMini from 'assets/cart-mini.svg';

const ResumenTicketMobile = (props) => {
  const { resumen, disabled } = props;
  const disabledClass = disabled ? 'disabled' : '';

  const handelClick = (event) => {
    const elementToToggle = event.target;
    elementToToggle.classList.toggle('open');
  };

  const scrollEvent = () => {
    document.addEventListener('scroll', () => {
      const element = document.querySelectorAll('.sticky-resumen-mobile')[0];
      if (element !== undefined) {
        if (window.scrollY <= 110) {
          element.classList.remove('active');
        } else {
          element.classList.add('active');
        }
      }
    });
  };

  function add(accumulator, a) {
    return accumulator + a;
  }

  const sumTotalPoints = () => {
    const arrayPoints = [];
    resumen.map((item) => {
      return arrayPoints.push(Number(item.points));
    });
    const sum = arrayPoints.reduce(add, 0);
    return sum.toLocaleString('es-MX');
  };

  useEffect(() => {
    scrollEvent();
  }, []);

  return (
    <div className={`sticky-resumen-mobile d-lg-none d-xl-none ${disabledClass}`}>
      <Accordion className="ticket-mobile">
        <Card>
          <Card.Header>
            <Accordion.Toggle
              as={Button}
              variant="link"
              eventKey="0"
              className="text-left not-link"
              onClick={handelClick}>
              <img src={cartMini} alt="shop-cart-mini" className="mr-15" />
              <h2 className="d-inline-block">Resumen de compra</h2>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <h3 className="pt-30 pb-15">Experiencias</h3>
              {
                resumen.map((ticket, index) => {
                  return (
                    /* eslint-disable */
                    <Row className="gift-label my-15" key={index}>
                      <Col xs={8}>
                        <p className="ft-12">
                          {ticket.isGift === true ? (
                            <i className="fas fa-gift mr-2" />
                          ) : '' }
                          {ticket.title}
                        </p>
                      </Col>
                      <Col xs={4} className="text-right">
                        <b>
                          {(Number(ticket.points)).toLocaleString('es-MX')}
                        </b>
                      </Col>
                    </Row>
                  );
                })
              }
                <Row className="pt-30">
                  <Col xs={8}>
                    <h5 className="ft-14 text-tangaroa">
                      <b>Total de Puntos Aeroméxico Rewards</b>  
                    </h5>
                  </Col>
                  <Col xs={4} className="ft-14 text-right text-tangaroa">
                  <b>
                    { sumTotalPoints() }
                  </b>
                  </Col>
                </Row>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

ResumenTicketMobile.defaultProps = {
  disabled: false,
};

ResumenTicketMobile.propTypes = {
  resumen: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
};

export default ResumenTicketMobile;
